/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.DivideTool = function( ) {
    // verify ready to send command
    var config = expocadfx.config;
    var elem = expocadfx.divideElements;
    var elemById = expocadfx.element.elementById;
    var FxEvent = expocadfx.fxevent;
    var txt = expocadfx.txt;
    var util = expocadfx.util;
    var doc = document;
    
    var VERTICAL_CENTER = 190;
    if(window.innerHeight < 601){
        var HORIZONTAL_CENTER = 165;
    } else {
        var HORIZONTAL_CENTER = 240;
    }
    
    var boothWidth = 0;
    var boothHeight = 0;
    var dimensions = { h: 0, w: 0};
    var aDecimal = 0.0;
    var aFtIn = { ft: 0, inch: 0 };
    var bDecimal = 0.0;
    var bFtIn = { ft: 0, inch: 0 };
    var isFeet = config.showUnits === "F";
    var isVertical = true;
    
    var bounds = null;
    var path = [];
    var mouseStart = { x:0, y:0};
    var scale = 0;
    var vMin = 0;
    var vMax = 380;
    var hMin = 50;
    var hMax = 430;
    var scaledWidth = 0;
    var scaledHeight = 0;
    
        // Tool dom
    var tool = doc.createElement( "div");
    var originalSize = doc.createElement( "span");
    var input = null;
    var label = doc.createElement( "label");
    
    var div = doc.createElement( "div");
    var span = doc.createElement( "span");
    var canvas = document.createElement( "canvas");
    var ctx = canvas.getContext( "2d");
    var divideLine = doc.createElement( "div");
    
    var aSide = elem.makeSideLabel( "a", isFeet);
    var bSide = elem.makeSideLabel( "b", isFeet);
    util.addClass( bSide, "vertical");
    
    tool.setAttribute( "id", "divideTool");
    tool.style.width = "380px";
    tool.style.position = "relative";
    
        // original booth size display
    span.className = "divide_size_label unselectable";
    span.textContent = txt.BOOTH_SIZE;
    div.appendChild( span);
    div.appendChild( originalSize);
    
    tool.appendChild( div);
    
        // divide direction radio buttons
    div = doc.createElement( "div");
    span = doc.createElement( "span");
    span.className = "divide_original_size unselectable";
    span.textContent = txt.DIVIDE;
    div.appendChild( span);
    
    input = elem.dirRadio( "dirV", "v");
    input.setAttribute( "checked", "true");
    label.setAttribute( "for", "dirV");
    label.className = "unselectable";
    label.textContent = txt.VERTICAL;
    div.appendChild( input);
    div.appendChild( label);
    
    input = elem.dirRadio( "dirH", "h");
    label = doc.createElement( "label");
    label.setAttribute( "for", "dirH");
    label.className = "unselectable";
    label.textContent = txt.HORIZONTAL;
    div.appendChild( input);
    div.appendChild( label);
    
    tool.appendChild( div);
    
    canvas.width = 380;
    canvas.height = 380;
    canvas.className = "unselectable";
    tool.appendChild( canvas);
    
    tool.appendChild( aSide);
    tool.appendChild( bSide);
    
    divideLine.setAttribute( "id", "divideLine");
    divideLine.className = "vertical";
    divideLine.style.backgroundColor = "#ff0000";
    tool.appendChild( divideLine);
    divideLine.style.display = "block";
    
    function enableEvents() {
        doc.getElementById( "dirV").addEventListener( "change", radioChange);
        doc.getElementById( "dirH").addEventListener( "change", radioChange);
    }
    
    function radioChange( evt) {
        if( evt.target.value === "h") {
            util.removeClass( divideLine, "vertical");
            util.removeClass( bSide, "vertical");
            util.addClass( divideLine, "horizontal");
            util.addClass( bSide, "horizontal");
            divideLine.style.left = "0px";
            divideLine.style.top = HORIZONTAL_CENTER + "px";
            isVertical = false;
            
            setDisplayDimensions( dimensions.height / 2, dimensions.height);
        }
        else {
            setDivideToVertical( false);
        }
    }
    
    function setDivideToVertical( isReset) {
        util.removeClass( divideLine, "horizontal");
        util.removeClass( bSide, "horizontal");
        util.addClass( divideLine, "vertical");
        util.addClass( bSide, "vertical");
        divideLine.style.top = "50px";
        divideLine.style.left = VERTICAL_CENTER + "px";
        isVertical = true;
        
        if( !isReset) {
            setDisplayDimensions( dimensions.width / 2, dimensions.width);
        }
    }
    
    function setDisplayDimensions( aSize, fullSize) {
        aDecimal = roundSideA( aSize);
        bDecimal = fullSize -aDecimal;
        
        if( isFeet) {
            aFtIn = decimalToFeetInch( aDecimal);
            elemById( "aFt").value = aFtIn.ft;
            elemById( "aIn").value = aFtIn.inch;

            bFtIn = decimalToFeetInch( bDecimal);
            elemById( "bFt").value = bFtIn.ft;
            elemById( "bIn").value = bFtIn.inch;
        }
        else {
            elemById( "aFt").value = aDecimal;
            elemById( "bFt").value = Math.round(parseFloat( bDecimal)*100)/100;
            document.getElementById('aFt').removeAttribute('readonly');

         //   elemById('aFt').removeAttribute( "readonly");
        }
    }
    
    function divideLineDown( evt) {
        divideLine.addEventListener( "mousemove", divideLineMove);
        divideLine.addEventListener( "pointermove", divideLineMove);
        canvas.addEventListener( "mousemove", divideLineMove);
        canvas.addEventListener( "pointermove", divideLineMove);
        
        divideLine.addEventListener( "mouseup", divideLineUp);
        divideLine.addEventListener( "pointerup", divideLineUp);
        canvas.addEventListener( "mouseup", divideLineUp);
        canvas.addEventListener( "pointerup", divideLineUp);
        mouseStart.x = evt.clientX;
        mouseStart.y = evt.clientY;
    }
    
    function divideLineUp() {
        divideLine.removeEventListener( "mousemove", divideLineMove);
        divideLine.removeEventListener( "pointermove", divideLineMove);
        canvas.removeEventListener( "mousemove", divideLineMove);
        canvas.removeEventListener( "pointermove", divideLineMove);
        canvas.removeEventListener( "mouseup", divideLineUp);
        canvas.removeEventListener( "pointerup", divideLineUp);
        divideLine.removeEventListener( "mouseup", divideLineUp);
        divideLine.removeEventListener( "pointerup", divideLineUp);
    }
    function divideLineMove( evt) {
        evt.preventDefault();
        var newX = 0;
        var newY = 0;
        
        if( isVertical) {
            newX = divideLine.offsetLeft + evt.clientX - mouseStart.x;
            if( newX < vMin) {
                newX = vMin;
                divideLineUp();
            }
            else if( newX > vMax) {
                newX = vMax;
                divideLineUp();
            }
            divideLine.style.left = newX + "px";
            
            setDisplayDimensions( dimensions.width * ( (newX - vMin) / scaledWidth), dimensions.width);
        }
        else {
            newY = divideLine.offsetTop + evt.clientY - mouseStart.y;
            if( newY < hMin) {
                newY = hMin;
                divideLineUp();
            }
            else if( newY > hMax) {
                newY = hMax;
                divideLineUp();
            }
            divideLine.style.top = newY + "px";
            
            setDisplayDimensions( dimensions.height * ( (newY - hMin) / scaledHeight), dimensions.height);
        }
        mouseStart.x = evt.clientX;
        mouseStart.y = evt.clientY;
    }
    
    function getBounds( path) {
        var i = 0;
        var pathLength = path.length;
        var obj = {
            minX: path[0].x,
            minY: path[0].y,
            maxX: path[0].x,
            maxY: path[0].y
        };

        for( i = 1; i < pathLength; i++) {
            obj.minX = Math.min( path[i].x, obj.minX);
            obj.minY = Math.min( path[i].y, obj.minY);
            obj.maxX = Math.max( path[i].x, obj.maxX);
            obj.maxY = Math.max( path[i].y, obj.maxY);
        }
        return obj;
    }
    
    function getDimensions( bthObj, normal) {       // add second parameter for units  - ONLY "F" now
        //  feet in decimal or feet-inch or Meters ( always meter decimal or allow cm??
        var dimStr = "";
        var index = -1;
        var str1 = "";
        var str2 = "";
        var obj = {};
        
        dimStr = isFeet ? bthObj.dimF : bthObj.dimM;
        
        index = dimStr.indexOf( "x");
        str1 = dimStr.substr( 0, index).trim();
        str2 = dimStr.substr( index + 1).trim();
        obj = {};
        
        if( normal) {
            obj.widthString = str1;
            obj.width = isFeet ? stringFeetToDecimal( str1) : Math.round(parseFloat( str1)*100)/100;
            obj.heightString = str2;
            obj.height = isFeet ?  stringFeetToDecimal( str2) : parseFloat( str2);
        }
        else {
            obj.widthString = str2;
            obj.width = isFeet ?  stringFeetToDecimal( str2) : parseFloat( str2);
            obj.heightString = str1;
            obj.height = isFeet ? stringFeetToDecimal( str1) : parseFloat( str1);
        }
        return obj;
    }
    
    function stringFeetToDecimal( value) {
        var ftIdx = value.indexOf( "'");
        var inch = 0;
        var size = parseFloat( value.substr( 0, ftIdx)); 
        
        if( ftIdx !== value.length - 1) {
            inch = value.substr( ftIdx, value.length -1);
            size += inch / 12;
        }
        return size;
    }
    
    function decimalToFeetInch( value) {
        var ft = Math.floor( value);
        var inch = Math.round( ( value - ft) * 12);
        return { ft: ft, inch: inch};
    }
    
    function roundSideA( value) {
        var ft = Math.floor( value);
        
        if( isFeet) {
            if( value - ft >= 0.25) {
                ft += 0.5;
            }
        }
        else {
                // metric  round to nearest 0.25 meter
            ft = Math.round( value / 0.25) * 0.25;
        }
        return ft;
    }
    
    function inputEntry( evt) {
        //  need to validate entry !
        // for isFeet valid entry between 0 and 11  AND update b side dimensions
        if( evt.target.value === "" && !evt.target.validity.valid) {
            evt.target.value = 0;
        }
        if( isFeet && evt.target.value > 11) {
            evt.target.value = Math.floor( evt.target.value / 10);
        }
        else if( !evt.target.validity.valid) {
            evt.target.value = Math.floor( parseFloat( evt.target.value));
        }

        if( isFeet) {
            aFtIn.inch = evt.target.value;
            aDecimal = aFtIn.ft + aFtIn.inch / 12;
            console.log(aFtIn.ft)
            console.log(aFtIn.inch)

            bDecimal = isVertical ? dimensions.height - aDecimal : dimensions.height - aDecimal;
            console.log(aDecimal)
            bFtIn = decimalToFeetInch( bDecimal);
            elemById( "bFt").value = bFtIn.ft;
            elemById( "bIn").value = bFtIn.inch;
        }
        else {
            aDecimal = evt.target.value;
            bDecimal = isVertical ? dimensions.width - aDecimal : dimensions.height - aDecimal;
            console.log(  "adjust b side -  a: " + aDecimal + "  b: " + bDecimal);
            elemById( "bFt").value = Math.round( bDecimal * 100) / 100;
        }
    }
    function inputEntryFt( evt) {
        const base = dimensions.height + dimensions.width;
        
        if( evt.target.value === "" && !evt.target.validity.valid) {
            evt.target.value = 0;
        }
        if( isFeet && evt.target.value > 11) {
            evt.target.value = Math.floor( evt.target.value / 10);
        }
        else if( !evt.target.validity.valid) {
            evt.target.value = Math.floor( parseFloat( evt.target.value));
        } 
        if( isFeet) {
            aFtIn.ft = evt.target.value;
            elemById( "bFt").value = (base - elemById('aFt').value) - dimensions.width;
        }
        else {
            aDecimal = evt.target.value
            bDecimal = isVertical ? dimensions.width - aDecimal : dimensions.height - aDecimal;
            console.log(  "adjust b side -  a: " + aDecimal + "  b: " + bDecimal);
            elemById( "bFt").value = Math.round( bDecimal * 100) - 100;
        }
    }

    function inputEntryValid(e){
        const base = isVertical ? dimensions.width : dimensions.height;

        if (!(/^(?:\d{1,2}(?:\.\d{0,6})?)?$/.test(elemById('aFt').value))){

            //swal("", "Please enter only numbers into amount textbox.", "error");
            elemById('aFt').value = base;
            elemById('bFt').value = 0;
        }
        if(elemById('aFt').value > base && e.keyCode != 46 && e.keyCode != 8){
            elemById('aFt').value = base;
            elemById('bFt').value = 0;

        }
        if(decimalPlaces(elemById('aFt').value) != 0 && e.keyCode != 8){

            var elem = elemById('aFt');

            if(elem.value % 1 != 0){
                if(e.inputType == "deleteContentBackward"){
                    elem.value = (Math.floor(elem.value)).toFixed(0);
                }
                else{
                    elem.value = (Math.round(elem.value*4)/4).toFixed(2);
                }             

                elemById('bFt').value = base - elem.value;
            }
        } 

        inputDivideLineMove();
    }

    function decimalPlaces(num) {
        var match = (''+num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        if (!match) { return 0; }
        return Math.max(
          0,
          // Number of digits right of decimal point.
          (match[1] ? match[1].length : 0)
          // Adjust for scientific notation.
          - (match[2] ? +match[2] : 0));
     }
    function inputDivideLineMove() {

        if( isVertical){
            
            var maxDist = vMax - vMin;
            var percent = elemById('aFt').value / dimensions.width;
            var newPos = maxDist * percent;
    
            divideLine.style.left = vMin + newPos + "px";
        }
        else{
            
            var maxDist = hMax - hMin;
            var percent = elemById('aFt').value / dimensions.height;
            var newPos = maxDist * percent;
            
            divideLine.style.top = hMin + newPos + "px";
        }
        
    }
    
    function drawBooth( bthObj) {
        var rot = 0;
        var textField = getBoothNumberTextObject( bthObj);
        var centerX = 0;
        var centerY = 0;
        var tempX = 0;
        var tempY = 0;
        var rotatedX = 0;
        var rotatedY = 0;
        var i = 0;
        var gr = bthObj.graphic;
        var offset = 0;
        var orientationNormal = true;
        
            //  clear and reset !!
        path = [];
        bounds = {};
        originalSize.textContent = isFeet ? bthObj.dimF : bthObj.dimM;
        elemById( "aNumber").value = bthObj.number;
        elemById( "bNumber").value = "";
        clearCanvas();
        elemById( "dirV").checked = true;
        
        if( textField) {
            rot = -1 * textField.rotation;
        }
        
        centerX = ( gr.minX + gr.maxX) / 2;
        centerY = ( gr.minY + gr.maxY) / 2;
        
            // normalize path  
        for( i = 0; i < gr.numPoints; i++) {
            tempX = gr.path[i].x - centerX;
            tempY = gr.path[i].y - centerY;
            
            if( rot !== 0) {
                rotatedX = tempX * Math.cos( rot) - tempY * Math.sin( rot);
                rotatedY = tempX * Math.sin( rot) + tempY * Math.cos( rot);

                path.push( { x: rotatedX, y: rotatedY});
            }
            else {
                path.push( { x: tempX , y: tempY});
            }
        }
        
        bounds = getBounds( path);
        boothWidth = bounds.maxX - bounds.minX;
        boothHeight = bounds.maxY - bounds.minY;

        if(window.innerHeight < 601){
            scale =  Math.min( 140 / boothWidth, 140 / boothHeight);
        } else {
            scale =  Math.min( 240 / boothWidth, 240 / boothHeight);
        }
        offset = VERTICAL_CENTER / scale;
        
        ctx.scale( scale, scale);
        ctx.strokeStyle = "#000000";
        ctx.fillStyle = "#ffffff";
        
        ctx.beginPath();
        ctx.moveTo( path[0].x + offset, path[0].y + offset);
        
        for( i = 1; i < gr.numPoints; i += 1) {
            ctx.lineTo( path[i].x + offset, path[i].y + offset);
        }
        
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        
        orientationNormal = boothWidth <= boothHeight;
        dimensions = getDimensions( bthObj, orientationNormal);
        
        vMin = VERTICAL_CENTER + ( bounds.minX * scale) - 2;
        vMax = VERTICAL_CENTER + ( bounds.maxX * scale) - 2;
        scaledWidth = vMax - vMin;
        
        hMin = HORIZONTAL_CENTER + ( bounds.minY * scale) - 2;
        hMax = HORIZONTAL_CENTER + ( bounds.maxY * scale) - 2;
        scaledHeight = hMax - hMin;
        
        setDivideToVertical( false);

        if( isFeet) {
            elemById( "aIn").addEventListener( "input", inputEntry);
            elemById( "aFt").addEventListener( "input", inputEntryFt);
        }
        else {
            elemById( "aFt").addEventListener( "input", inputEntry);

        }
        elemById( "aNumber").addEventListener( "input", checkBoothNumbers);
        elemById( "bNumber").addEventListener( "input", checkBoothNumbers);
        elemById( "aFt").addEventListener( "input", inputEntryValid);
        divideLine.addEventListener( "mousedown", divideLineDown);
        divideLine.addEventListener( "pointerdown", divideLineDown);
    }
    
    function checkBoothNumbers() {
            doc.dispatchEvent( new FxEvent( "Divide_Booth_Numbers", null));
    }
    
    function getBoothNumberTextObject( boothObj) {
        var obj = null;
        var i = 0;
        
        if( boothObj.graphic.text.length > 0) {
            for( i = 0; i < boothObj.graphic.text.length; i++) {
                if( boothObj.graphic.text[i].text === String( boothObj.number)) {
                    obj = boothObj.graphic.text[i];
                    break;
                }
            }
        }
        return( obj);
    }
    
    function closeWindow() {
        path = [];
        bounds = {};
        originalSize.textContent = "";
        elemById( "aNumber").value = "";
        elemById( "bNumber").value = "";
        clearCanvas();
        elemById( "dirV").checked = true;
        setDivideToVertical( true);
        elemById( "aFt").value = 0;
        elemById( "bFt").value = 0;
        if( elemById( "aIn")){
            elemById( "aIn").value = 0;
            elemById( "bIn").value = 0;
        }
    }
    
    function clearCanvas() {
        ctx.setTransform(1,0,0,1,0,0);
        ctx.clearRect(0, 0, 380, 380);
    }
    
    function getParameters() {
        var aDim = elemById( "aFt").value;
//        var bDim = elemById( "bFt").value;
        if( isFeet) {
            aDim += "'";
            if( elemById( "aIn").value !== "") {
                aDim += elemById( "aIn").value + "%22";
            }
//            bDim += "'";
//            if( elemById( "aIn").value !== "") {
//                bDim += elemById( "bIn").value + "%22";
//            }
        }
        else {
            aDim += "M";
//            bDim += "M";
        }
        var obj = {
            aNumber: elemById( "aNumber").value,
            bNumber: elemById( "bNumber").value,
            sizeX: 0,
            sizeY: 0
        };
        
        obj.sizeX = isVertical ? aDim : dimensions.widthString;
        obj.sizeY = isVertical ? dimensions.heightString : aDim;
        
        
        return obj;
    }

	
    
    return {
        tool: tool,
        clear: clearCanvas,
        close: closeWindow,
        drawBooth: drawBooth,
        enableEvents: enableEvents,
        getParameters: getParameters
    };
};